import React, { ComponentProps, FunctionComponent } from 'react';
import styled from 'styled-components';

import { Button } from './Button';
import { buttonStyles } from './buttonStyles';

type Props = ComponentProps<typeof Button> & {
  size?:
    | 'small'
    | 'medium'
    | 'large'
    // There shouldn't be `sm`, but there are some components using it
    // TODO: fix existing usages of sm
    | 'sm';
  boxShadow?: string;
  reverse?: boolean;
  blue?: boolean;
  green?: boolean;
  square?: boolean;
  light?: boolean;
  $transparent?: boolean;
};

export const ButtonWithStyles: FunctionComponent<Props> = styled(
  ({
    size: sizeProp,
    boxShadow,
    borderRadius,
    reverse,
    blue,
    green,
    square,
    light,
    ...buttonProps
  }: Props) => (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Button {...buttonProps} />
  )
).attrs((props) => ({
  type: props.type || 'button',
}))`
  ${buttonStyles}
`;
